import { isLocationOnboarding } from '../services/utils';

const DOCUMENT_PATH = '/app/onboarding/documents',
  PROFILE_PATH = '/app/onboarding',
  WEBSITE_PATH = '/app/onboarding/website';

export const PERMISSIONS_LIST = {
  BASIC_PERMISSIONS: 'basic_permissions',
  READ_TRANSCATIONS: 'read_transactions',
  READ_SETTLEMENTS: 'read_settlements',
  MANAGE_REFUNDS: 'manage_refunds',
  READ_DASHBOARD_PAYUMONEY: 'read_dashboard_payumoney',
  USER_PROFILE: 'user_profile',
  UPDATE_USER_PROFILE: 'update_user_profile',
  MANAGE_NOTIFICATIONS: 'manage_notifications',
  MANAGE_CHECKOUTS: 'manage_checkouts',
  MANAGE_WEBHOOKS: 'manage_webhooks',
  MANAGE_CREDENTIALS: 'manage_credentials',
  MANAGE_PAYMENT_PRODUCTS: 'manage_payment_products',
  MANAGE_CREDENTIALS: 'manage_credentials',
  MANAGE_ACCESS: 'manage_thirdparty_access',
  MANAGE_TEAM_ACCOUNTS: 'manage_team_accounts'
}

export const TIMELINE_STAGES = {
  accountStatus: {
    success: {
      label: 'Account created',
    },
  },
  profileStatus: {
    success: {
      label: 'Profile completed',
    },
    inProgress: {
      label: 'Complete profile in progress',
      stageMsg: 'Enter business, PAN,website and Bank details',
      timelineMsg: 'Settlement on hold, Please go ahead and complete your profile',
      link: {
        text: 'COMPLETE',
        to: (onBoardingHost, careHost) => isLocationOnboarding() ? '/onboarding' : onBoardingHost + PROFILE_PATH,
        notADashboardRoute: () => !isLocationOnboarding(),
        permissionString: PERMISSIONS_LIST.USER_PROFILE
      },
    },
    locked: {
      label: '',
      stageMsg: '',
      timelineMsg: '',
    },
    failure: {
      label: '',
      stageMsg: '',
      timelineMsg: '',
    },
  },
  bankStatus: {
    success: {
      label: 'Bank Verified',
    },
    inProgress: {
      conditional: true,
      default: {
        label: 'Bank Verification in progress',
        stageMsg: 'we will deposit a small amount in your bank account',
        timelineMsg: 'Settlement on Hold, we will deposit a small amount in your bank account',
      },
      PENNY_PENDING: {
        label: 'Bank Verification in progress',
        stageMsg: 'we will deposit a small amount in your bank account',
        timelineMsg: 'Settlement on Hold, we will deposit a small amount in your bank account',
      },
      PENNY_DEPOSITED: {
        link: {
          text: 'VERIFY NOW',
          to: (onBoardingHost, careHost) => isLocationOnboarding() ? '/onboarding' : onBoardingHost + PROFILE_PATH,
          notADashboardRoute: () => !isLocationOnboarding()
        },
        label: 'Bank Verification in progress',
        stageMsg: 'small amount is deposited in your bank account',
        timelineMsg: 'Please go ahead and verify your bank account to start document upload',
      },
    },
    locked: {
      label: 'Bank Verification pending',
      stageMsg: `<div>
                    Once profile details are completed
                    We verify your bank account in two steps
                  </div>
                  <br>
                  <div>
                    Step 1: PayU Deposits a small amount between Rs 1 to 5 in your provided bank account number
                  </div>
                  <br>
                  <div>
                    Step 2: Check your bank statement and enter the small amount on profile screen to verify your bank account
                  </div>
                  `,
      timelineMsg: '',
    },
    failure: {
      conditional: true,
      default: {
        link: {
          text: 'CONTACT US',
          to: (onBoardingHost, careHost) => careHost,
          notADashboardRoute: () => true
        },
        label: 'Bank Verification Failed',
        stageMsg: '',
        timelineMsg: 'We failed to verify your bank account, please update your bank details to retry',
      },
      PENNY_DEPOSIT_FAILED: {
        link: {
          text: 'CONTACT US',
          to: (onBoardingHost, careHost) => careHost,
          notADashboardRoute: () => true
        },
        label: 'Bank Verification Failed',
        stageMsg: '',
        timelineMsg: 'We failed to verify your bank account, please update your bank details to retry',
      },
      PENNY_ATTEMPTS_EXHAUSTED: {
        link: {
          text: 'CONTACT US',
          to: (onBoardingHost, careHost) => careHost,
          notADashboardRoute: () => true
        },
        label: 'Bank Verification attemps exhausted',
        stageMsg: '',
        timelineMsg: 'You exhaused bank verification attempts, please contact us for more information',
      },
    },
  },
  websiteStatus: {
    success: { label: 'Website Verified' },
    inProgress: {
      WEBSITE_VERIFICATION_IN_PROGRESS: {
        label: 'Website Verification in Progress',
        stageMsg: 'It will take 2 business days to verify your website.',
        timelineMsg: 'Website verification is in process, we will take two business days to verify your website'
      },
      conditional: true,
      default: {
        link: {
          text: 'SUBMIT',
          to: (onBoardingHost, careHost) => isLocationOnboarding() ? '/onboarding/website' : onBoardingHost + WEBSITE_PATH,
          notADashboardRoute: () => !isLocationOnboarding()
        },
        label: 'Website Details Pending',
        stageMsg: 'Submit your Website/App details'
      }
    },
    locked: {
      label: 'Website Verification Pending',
      stageMsg: `<div>Please ensure your website has following checks for faster approval:</div>
                <div>
                  1. Homepage should be available
                </div>
                <div>
                  2. Checkout page should be available
                </div>
                <div>
                  3. Terms and Conditions should be available
                </div>
                Note: Total transaction Limit of 50,000 on your account will be removed from your account after website approval`,
      timelineMsg: '',
    },
    failure: {
      link: {
        text: 'SUBMIT',
        to: (onBoardingHost, careHost) => isLocationOnboarding() ? '/onboarding/website' : onBoardingHost + WEBSITE_PATH,
        notADashboardRoute: () => !isLocationOnboarding()
      },
      label: 'Website Verification Error',
      stageMsg: 'Please submit additional details',
      timelineMsg: `Website couldn't be verified, please contact us for more information`,
    },
  },
  documentStatus: {
    success: {
      label: 'Document Verified',
    },
    inProgress: {
      conditional: true,
      default: {
        link: {
          text: 'UPLOAD',
          to: (onBoardingHost, careHost) => isLocationOnboarding() ? '/onboarding/documents' : onBoardingHost + DOCUMENT_PATH,
          notADashboardRoute: () => !isLocationOnboarding()
        },
        label: 'Upload Document in progress',
        stageMsg: 'Upload self attested documents',
        timelineMsg: 'Your service agreement is ready, please upload the documents to start the verification process',
      },
      DOCS_VERIFICATION_PENDING: {
        label: 'Document Verification in progress',
        stageMsg: 'Upload self attested documents',
        timelineMsg: 'Document verification is in process, we will take two business days to verify your documents',
      },
      ACCOUNT_CREATION_PENDING: {
        link: {
          text: 'UPLOAD',
          to: (onBoardingHost, careHost) => isLocationOnboarding() ? '/onboarding/documents' : onBoardingHost + DOCUMENT_PATH,
          notADashboardRoute: () => !isLocationOnboarding()
        },
        label: 'Upload Document in progress',
        stageMsg: 'Upload self attested documents',
        timelineMsg: 'Your service agreement will be generated shortly, please upload the remaining documents.',
      },
    },
    locked: {
      label: 'Upload Document Pending',
      stageMsg: `After Profile verification is complete documentation works in two steps
                  <div>
                    Step 1. Upload scanned copy of business documents.
                  </div>
                  <br>
                  <div>
                    Step 2. Our team verifies the documents within 2 business days
                  </div>`,
      timelineMsg: '',
    },
    failure: {
      link: {
        text: 'REUPLOAD',
        to: (onBoardingHost, careHost) => isLocationOnboarding() ? '/onboarding/documents' : onBoardingHost + DOCUMENT_PATH,
        notADashboardRoute: () => !isLocationOnboarding()
      },
      label: 'Document Verification Error',
      stageMsg: '',
      timelineMsg: 'Few documents you uploaded are incorrect, please reupload to proceed',
    },
  },
  settlementStatus: {
    success: {
      label: 'Settlement enabled to verified bank account',
      stageMsg: '',
      timelineMsg: 'CONGRATULATIONS! Your account is active and settlements are enabled in your bank account',
    },
    inProgress: {
      label: 'Settlement on hold',
      stageMsg: '',
      timelineMsg: 'Settlement on hold, your bank account details not updated with our partner bank',
    },
    failure: {
      conditional: true,
      NODAL_FAILED: {
        link: {
          text: 'CONTACT US',
          to: (onBoardingHost, careHost) => careHost,
          notADashboardRoute: () => true
        },
        label: 'Settlement verification failed',
        stageMsg: '',
        timelineMsg: 'Settlement on hold, your bank account details could not updated with our partner bank',
      },
      SETTLEMENT_ON_HOLD: {
        label: 'Settlement verification failed',
        stageMsg: '',
        timelineMsg: 'Your account has been put on settlement hold for risk assessment',
      },
    },
    locked: {
      label: 'Settlement enabled to verified bank account',
      stageMsg: 'Once Documents are Verified and Website is approved, transactions will be settled into your bank account within two days',
    },
  },
};

export const FAILURE = 'FAILURE';
export const IN_PROGRESS = 'IN_PROGRESS';
export const COMPLETED = 'COMPLETED';
export const ERROR = 'ERROR';
export const LOCKED = 'LOCKED';

export const TIMELINE_STATUS = {
  LOCKED,
  IN_PROGRESS,
  COMPLETED,
  FAILURE,
  ERROR
};

export const CONDITIONAL_STATUS = {
  PENNY_DEPOSIT_FAILED: 'PENNY_DEPOSIT_FAILED',
  PENNY_ATTEMPTS_EXHAUSTED: 'PENNY_ATTEMPTS_EXHAUSTED',
  PENNY_PENDING: 'PENNY_PENDING',
  PENNY_DEPOSITED: 'PENNY_DEPOSITED',
  LOB_NOT_VERIFIED: 'LOB_NOT_VERIFIED',
  DOCS_VERIFICATION_PENDING: 'DOCS_VERIFICATION_PENDING',
  NODAL_FAILED: 'NODAL_FAILED',
  SETTLEMENT_ON_HOLD: 'SETTLEMENT_ON_HOLD',
  ACCOUNT_CREATION_PENDING: 'ACCOUNT_CREATION_PENDING',
  WEBSITE_VERIFICATION_IN_PROGRESS: 'WEBSITE_VERIFICATION_IN_PROGRESS'
};
